import { isString } from '@direct-frontend/stdlib';

export function formatPhoneNumber(input: unknown): string | undefined {
    if (!isString(input)) {
        return undefined;
    }

    const digits = input.replace(/\D/g, '');

    if (digits.length !== 11 || (digits[0] !== '7' && digits[0] !== '8')) {
        return undefined;
    }

    return `8 (${digits.substring(1, 4)}) ${digits.substring(4, 7)}-${digits.substring(7, 9)}-${digits.substring(9, 11)}`;
}
